import './index.css'

const SalaryType = props => {
  const {eachSalary, onChangeSalary} = props
  const {label, salaryRangeId} = eachSalary

  const onClickSalary = () => {
    onChangeSalary(salaryRangeId)
  }

  return (
    <li>
      <input
        type="radio"
        id={salaryRangeId}
        onClick={onClickSalary}
        name="salary"
        value={salaryRangeId}
      />
      <label htmlFor={salaryRangeId} className="employ-label">
        {label}
      </label>
    </li>
  )
}

export default SalaryType
